<template>
  <div class="card">
    <div class="card-body">
      <div class="change-product-seller">
        <h5 class="mb-0">CUSTOMER</h5>
         
        <p v-if="product_detail.customer">
          <strong> {{product_detail.customer.fname ? product_detail.customer.fname + ' ' + product_detail.customer.lname  : ''}}</strong> <br/>
          <span v-if="product_detail.customer.mobile">{{product_detail.customer.mobile}} <br/></span>
          <span v-if="product_detail.customer.email">{{product_detail.customer.email}} <br/></span>
        </p>
         <vue-autosuggest
            :suggestions="customerSuggestions"
            :input-props="{class:'form-control', id:'autosuggest_customer_input', placeholder:'Change Customer'}"
            @input="onChangeCustomerInput"
            @selected="selectCustomerHandler"
            @click="onChangeCustomerInput"
            :getSuggestionValue="customerSuggestionsValue"
          >  
          <template slot-scope="{suggestion}">
            <span class="my-suggestion-item" v-html="suggestion.item.fname + ' ' + suggestion.item.lname"></span>
          </template>
        </vue-autosuggest>
        <p class="mt-2 mb-0"> <em>Cant find? <router-link :to="{ name: 'SuperadminCustomersAdd', query: { redirect: 'SuperadminRegisteredProductEdit', id: $route.params.id }}">Add customer</router-link></em></p>
        <button class="btn btn-primary rounded mt-3" @click.prevent="updateCustomer()">Update</button> 
      </div>
    </div>
  </div>
</template>

<script>
import Env from '@/env';
import AuthApis from '@/controllers/AuthApis';
import { VueAutosuggest } from 'vue-autosuggest';

export default {
  components: {
    VueAutosuggest
  },
  props: ['product_detail'],
  data() {
    return {
      customerSuggestions: [
        {
          data:[]
        }
      ],
    }
  },
  methods:{

    onChangeCustomerInput: _.debounce(function(name){

      if(name == null) {
        name = document.getElementById('autosuggest_customer_input').value;
      }

      const url = `${Env.baseUrl}/superadmin/users/suggest-user?type=customer`;
      AuthApis.postApi(url, {
        name: name
      }).then(res => {
        this.customerSuggestions[0].data = res.data.payload;
      }).catch(err => {
        console.log(err)
      })
      
    }, 800),


    selectCustomerHandler(obj) {
      this.product_detail.customer_id = obj.item.id;
      this.product_detail.customer = obj.item;
      this.customerSuggestions[0].data = [];
    },

    customerSuggestionsValue(obj) {
      return obj.item.fname +  (obj.item.lname ? ' ' + obj.item.lname : '') ;
    },
    
    updateCustomer() {
      const url = `${Env.baseUrl}/superadmin/users/update-user/${this.product_detail.id}`;
      AuthApis.postApi(url, {
        type: 'customer',
        user_id: this.product_detail.customer_id,
      }).then(res => {
        this.$toasted.global.success({
          message: res.data.message,
        })
      }).catch(err => {
        console.log(err)
      })
    },

  }
}
</script>